import {
    FETCH_STOCK_MOVEMENTS_START,
    FETCH_STOCK_MOVEMENTS_SUCCESS,
    FETCH_STOCK_MOVEMENTS_ERROR,
    FETCH_STOCK_HISTORY_START,
    FETCH_STOCK_HISTORY_SUCCESS,
    FETCH_STOCK_HISTORY_ERROR,
    SET_STOCK_VIEW_MODE,
    CLEAR_STOCK_MOVEMENTS
} from '../actions/stockMovementAction';

/**
 * State initial pour les mouvements de stock
 */
const initialState = {
    // Mouvements enrichis (nouvelle API)
    movements: [],
    currentStock: 0,
    totalMovements: 0,
    
    // Mouvements ignorés (pour debugging/audit)
    ignoredMovements: [],
    totalHistories: 0,
    totalIgnored: 0,
    
    // Historique classique (ancienne API)
    history: [],
    
    // Métadonnées
    shopId: null,
    productId: null,
    stockID: null,
    
    // État de chargement
    loading: false,
    error: null,
    
    // Mode d'affichage
    viewMode: localStorage.getItem('stock_history_view_preference') || 'enhanced',
    
    // Timestamp du dernier chargement
    lastFetch: null
};

/**
 * Reducer pour gérer les mouvements de stock
 */
export default function stockMovementReducer(state = initialState, action) {
    switch (action.type) {
        // ========== FETCH STOCK MOVEMENTS (Nouvelle API) ==========
        case FETCH_STOCK_MOVEMENTS_START:
            return {
                ...state,
                loading: true,
                error: null,
                shopId: action.payload.shopId,
                productId: action.payload.productId
            };
            
        case FETCH_STOCK_MOVEMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                movements: action.payload.movements,
                currentStock: action.payload.currentStock,
                totalMovements: action.payload.totalMovements,
                ignoredMovements: action.payload.ignoredMovements || [],
                totalHistories: action.payload.totalHistories || 0,
                totalIgnored: action.payload.totalIgnored || 0,
                shopId: action.payload.shopId,
                productId: action.payload.productId,
                lastFetch: new Date().toISOString()
            };
            
        case FETCH_STOCK_MOVEMENTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                movements: [],
                currentStock: 0,
                totalMovements: 0,
                ignoredMovements: [],
                totalHistories: 0,
                totalIgnored: 0
            };
            
        // ========== FETCH STOCK HISTORY (Ancienne API) ==========
        case FETCH_STOCK_HISTORY_START:
            return {
                ...state,
                loading: true,
                error: null,
                stockID: action.payload
            };
            
        case FETCH_STOCK_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                history: action.payload.history,
                stockID: action.payload.stockID,
                lastFetch: new Date().toISOString()
            };
            
        case FETCH_STOCK_HISTORY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                history: []
            };
            
        // ========== VIEW MODE ==========
        case SET_STOCK_VIEW_MODE:
            return {
                ...state,
                viewMode: action.payload
            };
            
        // ========== CLEAR ==========
        case CLEAR_STOCK_MOVEMENTS:
            return {
                ...initialState,
                viewMode: state.viewMode // Conserver la préférence de vue
            };
            
        default:
            return state;
    }
}

